import { TAppState } from '../types';

export const selectBillingUserType = (state: TAppState) => {
  return state.user.billingUserType;
};
